import { AutoComplete } from "antd";
import { DownOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const PropertyAutoComplete = ({
  properties,
  value,
  onChange,
  onSelect,
  style,
  ...props
}) => {
  const options = properties
    .filter((property) =>
      property.PropertyName.toLowerCase().includes((value || "").toLowerCase())
    )
    .map((property) => ({
      value: property.PropertyName,
      PropertyKey: property.PropertyKey,
      Communities: property.Communities,
    }));

  return (
    <AutoComplete
      style={{ borderRadius: "2.5rem", ...style }}
      options={options}
      placeholder="Select or type the property"
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      allowClear
      filterOption={false}
      suffixIcon={<DownOutlined />}
      {...props}
    />
  );
};

PropertyAutoComplete.propTypes = {
  properties: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default PropertyAutoComplete;